import { BackNavigationButton } from "$components/button/back-button";
import { lazyLoad } from "$routes/_lib/lazy-load";
import { linkToAdminControlPanel } from "$routes/admin/links";
import { defineMessages } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";
import ClinicalProductPage from "./_lib/clinical-product-page";
import { linkToClinicalProductManagement, linkToVMP, linkToVTM } from "./links";

const messages = defineMessages({
  backToVTM: {
    id: "clinicalProductManagement.navigation.backToVTM",
    defaultMessage: "Back to VTM",
  },
  backToVMP: {
    id: "clinicalProductManagement.navigation.backToVMP",
    defaultMessage: "Back to VMP",
  },
  backToControlPanel: {
    id: "clinicalProductManagement.navigation.backToControlPanel",
    defaultMessage: "Back to Control Panel",
  },
  backToClinicalProducts: {
    id: "clinicalProductManagement.navigation.backToClinicalProducts",
    defaultMessage: "Back to Clinical Products",
  },
});

const ClinicalProductManagementPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({
    default: module.default.ClinicalProductManagementPage,
  })),
);

const VtmPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.VtmPage })),
);

const VmpPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.VmpPage })),
);

const AddVmpPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.AddVmpPage })),
);

const AddAmpPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.AddAmpPage })),
);

const EditVtmPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.EditVtmPage })),
);

const EditVmpPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.EditVmpPage })),
);

const VtmBulkOperationsPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.VtmBulkOperationsPage })),
);

const VmpBulkOperationsPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.VmpBulkOperationsPage })),
);

const AmpBulkOperationsPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicalProductManagement" */
    "./chunk"
  ).then((module) => ({ default: module.default.AmpBulkOperationsPage })),
);

const EditVtmRoute = () => {
  const location = useLocation();
  const vtmId = location.pathname.split("/")[3];
  return (
    <>
      <BackNavigationButton to={linkToVTM(vtmId)} label={messages.backToVTM} />
      <EditVtmPage />
    </>
  );
};

const EditVmpRoute = () => {
  const location = useLocation();
  const vmpId = location.pathname.split("/")[3];
  return (
    <>
      <BackNavigationButton to={linkToVMP(vmpId)} label={messages.backToVMP} />
      <EditVmpPage />
    </>
  );
};

const AddVmpRoute = () => {
  const location = useLocation();
  const vtmId = location.pathname.split("/")[3];
  return (
    <>
      <BackNavigationButton to={linkToVTM(vtmId)} label={messages.backToVTM} />
      <AddVmpPage />
    </>
  );
};

const AddAmpRoute = () => {
  const location = useLocation();
  const vmpId = location.pathname.split("/")[3];
  return (
    <>
      <BackNavigationButton to={linkToVMP(vmpId)} label={messages.backToVMP} />
      <AddAmpPage />
    </>
  );
};

export function ClinicalProductManagementRoutes() {
  return (
    <ClinicalProductPage>
      <Routes>
        <Route
          index
          element={
            <>
              <BackNavigationButton
                to={linkToAdminControlPanel()}
                label={messages.backToControlPanel}
              />
              <ClinicalProductManagementPage />
            </>
          }
        />
        <Route path="vtm">
          <Route path=":id">
            <Route
              index
              element={
                <>
                  <BackNavigationButton
                    to={linkToClinicalProductManagement()}
                    label={messages.backToClinicalProducts}
                  />
                  <VtmPage />
                </>
              }
            />
            <Route path="edit" element={<EditVtmRoute />} />
            <Route path="add-vmp" element={<AddVmpRoute />} />
          </Route>
        </Route>
        <Route path="vmp">
          <Route index element={<VmpBulkOperationsPage />} />
          <Route path=":id">
            <Route
              index
              element={
                <>
                  <BackNavigationButton
                    to={linkToClinicalProductManagement()}
                    label={messages.backToClinicalProducts}
                  />
                  <VmpPage />
                </>
              }
            />
            <Route path="edit" element={<EditVmpRoute />} />
            <Route path="add-amp" element={<AddAmpRoute />} />
          </Route>
        </Route>
        <Route path="bulk">
          <Route path="vtm" element={<VtmBulkOperationsPage />} />
          <Route path="vmp" element={<VmpBulkOperationsPage />} />
          <Route path="amp" element={<AmpBulkOperationsPage />} />
        </Route>
      </Routes>
    </ClinicalProductPage>
  );
}
